// Shipping Protection aan- en uitzetten zonder de pagina te herladen.
// Shopify's cart-drawer luistert op het publish/subscribe-systeem van Dawn;
// wij halen daarna gewoon de secties opnieuw op.
(() => {
  const SELECTOR = '[data-protection-variant]';

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`${url} gaf ${res.status}`);
    return res.json();
  }

  async function toggle(input) {
    const variantId = Number(input.dataset.protectionVariant);
    if (!variantId) return;

    const label = input.closest('label');
    label?.setAttribute('aria-busy', 'true');

    try {
      if (input.checked) {
        await post('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      } else {
        await post('/cart/change.js', { id: String(variantId), quantity: 0 });
      }
      // Dawn herbouwt de drawer op basis van zijn eigen events; een reload van
      // de cart-secties is hier het eenvoudigst en blijft juist.
      document.dispatchEvent(new CustomEvent('offer:cart-updated'));
      window.location.reload();
    } catch (err) {
      console.error('[offer] Shipping Protection bijwerken mislukt:', err);
      input.checked = !input.checked;
      label?.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(SELECTOR);
    if (input) toggle(input);
  });
})();

// Vaste koopbalk: tonen zodra de echte Add to cart-knop weg is gescrold.
(() => {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  const realButton = document.querySelector('.product-form__submit');
  if (!realButton || !('IntersectionObserver' in window)) return;

  bar.hidden = false;
  const io = new IntersectionObserver(
    ([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.toggleAttribute('data-visible', passed);
    },
    { threshold: 0 }
  );
  io.observe(realButton);
})();

// De Facebook-teller telt op van 0 naar de eindwaarde, zoals het script van
// Jula (2 seconden). setInterval in plaats van requestAnimationFrame, want
// rAF staat stil in een verborgen tabblad en dan bleef er "0" staan.
(() => {
  const el = document.querySelector('[data-fb-counter]');
  if (!el) return;
  const target = parseFloat(el.dataset.target);
  if (!Number.isFinite(target)) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = target.toFixed(1);
    return;
  }

  const duration = 2000;
  const begin = Date.now();
  el.textContent = '0.0';
  const timer = setInterval(() => {
    const p = Math.min((Date.now() - begin) / duration, 1);
    el.textContent = (target * p).toFixed(1);
    if (p >= 1) clearInterval(timer);
  }, 40);
})();
